import {
 Box, Divider, Skeleton, Typography,
} from '@mui/material';
import { BarPlot, ResponsiveChartContainer } from '@mui/x-charts';
import React from 'react';
import { colors } from '../../theme';

function BehaviorConcernsLoader() {
  return (
    <>
      <Box
        sx={{
          py: 2,
        }}
      >
        <Typography variant="h5" sx={{ mb: 0.5 }}><Skeleton width={332} /></Typography>
        <Typography variant="body2"><Skeleton width={300} /></Typography>
      </Box>
      <Box>
        <ResponsiveChartContainer
          xAxis={[{
            scaleType: 'band',
            data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
          }]}
          series={[
            {
              data: [20, 10, 20, 10, 20, 10, 20, 10, 20, 30, 10],
              type: 'bar',
              color: colors.grey['300'],
            },
            {
              data: [30, 15, 10, 20, 30, 30, 40, 10, 20, 10, 15],
              type: 'bar',
              color: colors.grey['100'],
            },
          ]}
          height={300}
        >
          <BarPlot />
        </ResponsiveChartContainer>
        <Divider sx={{ my: 3 }} />
      </Box>
      <Box
        sx={{
          py: 2,
        }}
      >
        <Typography variant="h5" sx={{ mb: 0.5 }}><Skeleton width={332} /></Typography>
        <Typography variant="body2"><Skeleton width={300} /></Typography>
      </Box>
      <Box>
        <ResponsiveChartContainer
          xAxis={[{
            scaleType: 'band',
            data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
          }]}
          series={[
            {
              data: [20, 10, 20, 10, 20, 10, 20, 10, 20, 30, 10],
              type: 'bar',
              color: colors.grey['300'],
            },
            {
              data: [30, 15, 10, 20, 30, 30, 40, 10, 20, 10, 15],
              type: 'bar',
              color: colors.grey['100'],
            },
          ]}
          height={300}
        >
          <BarPlot />
        </ResponsiveChartContainer>
      </Box>
    </>
  );
}

export default BehaviorConcernsLoader;
